import { ReactNode, FunctionComponent } from 'react';
import { StepWrapper } from './styles';

export interface StepProps {
  title?: ReactNode;
  content?: ReactNode;
  img: FunctionComponent;
  imgAlt: string;
  contentSize?: 'normal' | 'large';
  titleCenter?: boolean;
  titleTipUpper?: boolean;
  contentTipUpper?: boolean;
}

export function Step({
  title,
  content,
  img: Img,
  contentSize = 'normal',
}: Readonly<StepProps>) {
  return (
    <StepWrapper size={contentSize}>
      {title}
      <main>
        <Img />
        {content}
      </main>
    </StepWrapper>
  );
}
